


























































































































































































































































































































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import PendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'
import SolicitacaoCancelamentoStore from '@/components/SolicitacaoCancelamento/Store/SolicitacaoCancelamentoStore'
import { TipoDocumentoUpload, TipoOrigemEnum, CancelarSolicitacaoParam } from '@/types/_'
import { Autorizacao } from '@/types/core'
import { DateTime } from 'luxon'
import { timeoutDefault, timeout, onlyNumber } from '@/utils/common'
import { Carater, Laudo } from '@/types/interfaces/Solicitacao'

@Component

export default class ComponentBackofficeAutorizacao extends Vue {
  @Prop({ required: false, default: false }) disabled: boolean
  @Prop({ required: false, default: false }) isReadOnlyPage: boolean

  autorizacao: Autorizacao.IAutorizacao = new Autorizacao.Autorizacao()

  $refs!: {
    dateA: any,
    dateB: any,
    autorizacaoForm: any,
    dialogAutorizacaoValidade: any,
    dialogDataAutorizacaoNaOperadora: any,
  }

  modalAutorizacaoValidade: boolean = false
  modalDataAutorizacaoNaOperadora: boolean = false
  loadSelecionar: boolean = false
  loadCancelar: boolean = false
  loadMotivosCancelamento: boolean = false
  mdCancelarSolicitacao: boolean = false
  observationIputDisabled: boolean = true
  regraObservacao: boolean = false

  get observacaoRules() { return this.regraObservacao }
  set observacaoRules(value: boolean) { this.regraObservacao = value }

  autorizacaoForm: any = {
    valid: true,
    autorizacaoValidade: ['EmAnalise', 'AutorizacaoPos'].includes(this.getBackofficeGlobalStore.solicitacao.statusAguardandoOperadora) ? [] : [v => !!v || 'Campo obrigatório.'],
    operadoraSenha: [],
    operadoraSenhaProvisoria: [],
    operadoraQuantidadeDiasAutorizado: [],
    protocoloOPME: [],
    // dataAutorizacaoNaOperadora: [],
    dataAutorizacaoNaOperadora: [v => this.validaDataAutorizacaoNaOperadora(v)],
    respostaOperadora: [v => ['Autorizada', 'AutorizadaParcial', 'Cancelada', 'EmAnalise', 'AutorizacaoPos'].includes(v) || 'Campo obrigatório.'],
    observacao: ['EmAnalise', 'AutorizacaoPos'].includes(this.getBackofficeGlobalStore.solicitacao.statusAguardandoOperadora) ? [] : [v => this.validaObservacao(v)],
  }

  get getSolicitacaoCancelamentoStore() {
    return getModule(SolicitacaoCancelamentoStore, this.$store)
  }

  get surgerySolicitationHasUrgencyAutorizationEnabled() {
    return this.getBackofficeGlobalStore.solicitacao.utilizaAnalisePreAutorizacaoUrgencia
      && this.getBackofficeGlobalStore.solicitacao.utilizaAguardandoAutorizacaoUrgencia
      && this.surgeryType && this.surgeryType.key === 'Urgencia'
      && (this.surgeryStatus === 'AguardandoAutorizacaoUrgencia' || this.surgeryStatus === 'AnalisePreAutorizacaoUrgencia')
  }

  get surgeryType() {
    return this.getBackofficeGlobalStore.solicitacao.carater as Carater
  }

  get surgeryStatus() {
    return this.getBackofficeGlobalStore.solicitacao.situacao.key
  }

  get canEditHealthInsuranceAttachment() {
    return !this.disabled
  }

  canDeleteHealthInsuranceAttachment(data: Laudo) {
    return this.canEditHealthInsuranceAttachment && data.tipoDocumento === 'AnexoOperadora'
  }

  get validityDateLabel() {
    if (this.autorizacaoForm.autorizacaoValidade.length > 0) {
      return 'Data de validade *'
    }

    return 'Data de validade'
  }

  validaDataAutorizacaoNaOperadora(value: any) {
    if (!!this.getBackofficeGlobalStore.solicitacao.dataAutorizacaoNaOperadoraObrigatoria && ['', null, undefined].includes(value)) return 'Campo obrigatório.'
    return false
    // if (this.getBackofficeGlobalStore.solicitacao.statusAguardandoOperadora !== 'Autorizada') return true
    // if (['', null, undefined].includes(value)) return 'Campo obrigatório.'
    // return false
  }

  validaObservacao(value) {
    if (this.observacaoRules) return true
    return !!value || 'Campo obrigatório.'
  }

  observacaoObrigatoria(status: string) {
    const { template } = this.getBackofficeGlobalStore
    if (template && template.formulario && template.formulario.guiaDeAutorizacao && template.formulario.guiaDeAutorizacao.campos) {
      return !!template.formulario.guiaDeAutorizacao.campos[status]
    }
    return false
  }

  toggleObservationEditMode() {
    this.observationIputDisabled = !this.observationIputDisabled
  }

  get loadingSelecionar() {
    return this.loadSelecionar
  }

  set loadingSelecionar(value: boolean) {
    this.loadSelecionar = value
  }

  get loadingCancelar() {
    return this.loadCancelar
  }

  set loadingCancelar(value: boolean) {
    this.loadCancelar = value
  }

  get modalCancelarSolicitacao() {
    return this.mdCancelarSolicitacao
  }

  set modalCancelarSolicitacao(value: boolean) {
    this.mdCancelarSolicitacao = value
  }

  get hasMotivo() {
    return !!this.getSolicitacaoCancelamentoStore.motivo
  }

  @Watch('modalCancelarSolicitacao')
  async onChangeModalCancelarSolicitacao(value) {
    if (value) {
      await timeoutDefault()
      const cancelarSolicitacaoParam: CancelarSolicitacaoParam = {
        solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
        tipoOrigem: TipoOrigemEnum.Autorizacao,
        situacao: this.getBackofficeGlobalStore.solicitacao.situacao,
        canceladoMotivo: {
          display: '',
          key: '',
        },
        modal: 'autorizarProcesso',
      }

      if (this.getBackofficeGlobalStore.solicitacao.canceladoMotivo) {
        cancelarSolicitacaoParam.canceladoMotivo = this.getBackofficeGlobalStore.solicitacao.canceladoMotivo
      }

      this.getSolicitacaoCancelamentoStore.setCancelarSolicitacaoParam(cancelarSolicitacaoParam)
      await this.getSolicitacaoCancelamentoStore.getMotivosCancelamentoAll({ hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId })
    } else {
      this.getSolicitacaoCancelamentoStore.setMotivosCancelamento([])
    }
  }

  async selecionar() {
    this.loadingSelecionar = true
    await timeout(800)
    this.loadingSelecionar = false
    this.modalCancelarSolicitacao = false
  }

  cancelar() {
    this.getSolicitacaoCancelamentoStore.setMotivo('')
    this.modalCancelarSolicitacao = false
  }

  respostaOperadoraChange(value: string) {
    this.$refs.autorizacaoForm.resetValidation()

    // Seta a flag de obrigatoriedade da observação
    this.observacaoRules = this.observacaoObrigatoria(value)

    switch (value) {
      case 'Cancelada':
        this.autorizacaoForm.autorizacaoValidade = []
        this.autorizacaoForm.dataAutorizacaoNaOperadora = []
        this.autorizacaoForm.observacao.push(v => this.validaObservacao(v))
        this.modalCancelarSolicitacao = true
        break

      case 'EmAnalise':
        this.autorizacaoForm.autorizacaoValidade = []
        this.autorizacaoForm.dataAutorizacaoNaOperadora = []
        this.autorizacaoForm.observacao = []
        this.getSolicitacaoCancelamentoStore.clear()
        break

      case 'AutorizacaoPos':
        this.autorizacaoForm.autorizacaoValidade = []
        this.autorizacaoForm.dataAutorizacaoNaOperadora = []
        this.autorizacaoForm.observacao = []
        this.getSolicitacaoCancelamentoStore.clear()
        break

      default:
        this.autorizacaoForm.autorizacaoValidade.push(v => !!v || 'Campo obrigatório.')
        this.autorizacaoForm.observacao.push(v => this.validaObservacao(v))
        this.getSolicitacaoCancelamentoStore.clear()
        break
    }
  }

  loadConfirmar: boolean = false
  loadVoltar: boolean = false
  loadDocumento: boolean = false
  loadDeletar: string = ''

  get loadingDeletar() {
    return this.loadDeletar
  }

  set loadingDeletar(value: string) {
    this.loadDeletar = value
  }

  get loadingDocumento() {
    return this.loadDocumento
  }

  set loadingDocumento(val: boolean) {
    this.loadDocumento = val
  }

  get loadingVoltar() {
    return this.loadVoltar
  }

  set loadingVoltar(val: boolean) {
    this.loadVoltar = val
  }

  get loadingConfirmar() {
    return this.loadConfirmar
  }

  set loadingConfirmar(val: boolean) {
    this.loadConfirmar = val
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getPendenciaStore() {
    return getModule(PendenciaStore, this.$store)
  }

  get getAnexos() {
    const anexos = this.getBackofficeGlobalStore.solicitacao.laudos.filter(c => c.tipoDocumento === TipoDocumentoUpload.AnexoOperadora) || []

    let guiaTissAnexo: Laudo | undefined
    if (this.getBackofficeGlobalStore.solicitacao.acoes.exibeGuiasDePrestadorOperadora) {
      guiaTissAnexo = this.getBackofficeGlobalStore.solicitacao.laudos.find(c => c.tipoDocumento === TipoDocumentoUpload.GuiaTissInternacao)
      if (guiaTissAnexo) {
        anexos.unshift(guiaTissAnexo)
      }
    }

    return anexos
  }

  set getAnexos(value) {
    this.getBackofficeGlobalStore.setLaudos(value)
  }

  get autorizacaoValidadeText() {
    if (!['', null, undefined].includes(this.getBackofficeGlobalStore.solicitacao.autorizacaoValidade)) {
      return DateTime.fromISO(this.getBackofficeGlobalStore.solicitacao.autorizacaoValidade).toFormat('dd/LL/yyyy')
    }
    return null
  }

  get dataAutorizacaoNaOperadoraText() {
    if (!['', null, undefined].includes(this.getBackofficeGlobalStore.solicitacao.dataAutorizacaoNaOperadora)) {
      return DateTime.fromISO(this.getBackofficeGlobalStore.solicitacao.dataAutorizacaoNaOperadora).toFormat('dd/LL/yyyy')
    }
    return null
  }

  async deleteLaudo(value) {
    this.loadingDeletar = value.id
    const request = await this.getBackofficeGlobalStore.deleteLaudo({ id: value.id, hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId })
    if (request.success) {
      if (request.success) {
        const removeArray: any[] = []

        for (let i = 0; i < this.getAnexos.length; i++) {
          if (this.getAnexos[i].id === value.id) {
            removeArray.push(i)
          }
        }

        for (let i = 0; i < removeArray.length; i++) {
          this.getAnexos.splice(removeArray[i], 1)
        }
      }
    }

    this.loadingDeletar = ''
  }

  async inputFileCotacaoOperadora(newFile, oldFile) {
    this.loadingDocumento = true

    if (newFile.identifier) return

    const form = new FormData()
    form.append('laudos', newFile.file)
    const params: any = {
      formData: form,
      tipoDocumento: TipoDocumentoUpload.AnexoOperadora,
    }

    const request = await this.getBackofficeGlobalStore.upload(params)

    if (!request.data || request.data.length === 0) {
      this.loadingDocumento = false
      return
    }

    // eslint-disable-next-line no-param-reassign
    newFile.identifier = request.data[0].id
    // eslint-disable-next-line no-param-reassign
    newFile.id = request.data[0].id
    // eslint-disable-next-line no-param-reassign
    newFile.url = request.data[0].url
    // eslint-disable-next-line no-param-reassign
    newFile.nomeOriginalArquivo = request.data[0].nomeOriginalArquivo
    // eslint-disable-next-line no-param-reassign
    newFile.tipoDocumento = TipoDocumentoUpload.AnexoOperadora
    this.getAnexos = newFile

    this.loadingDocumento = false
  }

  onlyNumberUtil(value: string) {
    return onlyNumber(value)
  }
}
